import { Core, EXPORTS_INSPECTIONS, EXPORT_JOB } from '../Core';
import type { IDownloadTypes } from '@/ui/components/CustomTable/exportToFile';

export type ExportFormat = IDownloadTypes;

export type ExportJobFile = {
  fileName: string;
  downloadUrl: string;
};

export type ExportJobState = {
  exportId: string;
  status: 'Queued' | 'Running' | 'Ready' | 'Failed';
  error?: string | null;
  processedCount?: number;
  totalCount?: number | null;
  files?: ExportJobFile[];
};

export type StartInspectionsExportBody = {
  filters?: unknown[];
  search?: string;
  sortField?: string;
  sortOrder?: string;
  includeDamages?: boolean;
  totalCount?: number;
  format: ExportFormat;
};

class ExportsApi extends Core {
  startInspectionsExport = (body: StartInspectionsExportBody) =>
    this.post<ExportJobState>(EXPORTS_INSPECTIONS(), body);

  getExportJob = (exportId: string) =>
    this.get<ExportJobState>(EXPORT_JOB(exportId));
}

export const exportsApi = new ExportsApi();
